// extracted by mini-css-extract-plugin
module.exports = {"calculator":"Comp_calculator__pua-H","calcTitle":"Comp_calcTitle__2FaUj"};